import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const TemperatureLogPage = lazy(() => import("./TemperatureLogPage"));

const TemperatureLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <TemperatureLogPage />
    </Suspense>
  );
};

export default TemperatureLogPageLazy;
